import React, { useEffect } from 'react';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Container } from '../../../../../symphony';

import { SlLEContext } from '../../../global-constants';
import { SlDataService } from '../../../services/sl-data.service';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ActionType, ModalKeys, RequestType } from '../../../global-interface';
import { SlFreeHeartScreen } from '../../../../../shared/public/SlFreeHeartScreen/SlFreeHeartScreen';

export function FreeHeartScreen() {
	const { actions$ } = Container.take(SlLEContext, SlActions);

	useEffect(() => {
		const { modals$ } = Container.take(SlLEContext, SlDataService);
		const unsubscriber = new Subject<void>();

		// TODO: recheck heart onLessonRanOutOfHearts funcionality
		let alreadyOpened = false;
		modals$
			.pipe(
				filter((m) => !!m),
				takeUntil(unsubscriber),
			)
			.subscribe((data) => {
				if (!alreadyOpened && data?.[ModalKeys.FreeHeartRefill]) {
					alreadyOpened = true;
					actions$.next({
						type: ActionType.OnFreeHeartScreenMount,
						requestType: RequestType.Parallel,
					});
				}
			});

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	const onRefillBtnClick = () => {
		actions$.next({
			type: ActionType.OnFreeHeartRefillCtaClick,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<SlFreeHeartScreen onFreeRefill={onRefillBtnClick} />
	);
}
